import {NotificationStatus} from "./notifications";
import {NotificationType} from "../../../model/notification/NotificationBase";

/**
 * Fetch notifications successful action.
 */
export const NOTIFICATIONS_FETCHED = "NOTIFICATIONS_FETCHED";
export type NOTIFICATIONS_FETCHED = { notifications: Array<NotificationType> }

/**
 * Mark notification as read/unread.
 */
export const NOTIFICATION_STATUS_UPDATED = "NOTIFICATION_STATUS_UPDATED";
export type NOTIFICATION_STATUS_UPDATED = { data: NotificationStatus[] }

/**
 * New notification arrived action.
 */
export const NEW_NOTIFICATION = "NEW_NOTIFICATION";
export type NEW_NOTIFICATION = { notification: NotificationType };

/**
 * Mark all notifications as read successful action.
 */
export const NOTIFICATIONS_MARKED_AS_READ = "NOTIFICATIONS_MARKED_AS_READ"

/**
 * Fetch notifications is unread successful action.
 */
export const NOTIFICATIONS_IS_UNREAD_FETCHED = "NOTIFICATIONS_IS_UNREAD_FETCHED"
export type NOTIFICATIONS_IS_UNREAD_FETCHED = { isUnread: boolean };
